export const STORE_PAGE_RULES = []

export const CPP_LINK_RULES = []

export const SHAME_PAGE_RULES = []
